import z from "zod";
export const DTOMCPStream = z.object({
    id: z.string().uuid(),
    projectFeatureId: z.string().uuid().optional(),
    projectDocumentId: z.string().uuid().optional(),
});
export const DTOMCPStreamUpdateInput = DTOMCPStream.omit({ id: true });
export const DTOMCPStreamResponse = z.object({
    stream: DTOMCPStream,
});
